import {SAMPLE_CONTENT} from 'consts/ftypes.js'

export function makeProfileSchema() {
  return [
    {
      type: 'container',
      className: 'profile-container',
      dir: 'row',
      gap: '3.2rem',
      opts: [
        {
          type: 'container',
          opts: [
            {
              type: 'container',
              dir: 'row',
              style: {marginBottom: '0.4rem'},
              opts: [
                {
                  field: 'first_name',
                  title: 'First Name',
                  type: 'text',
                  spellcheck: false,
                  maxlength: 50,
                },
                {
                  field: 'last_name',
                  title: 'Last Name',
                  type: 'text',
                  maxlength: 50,
                },
              ]
            },
            {
              field: 'title',
              title: 'Title',
              type: 'text',
              maxlength: 100,
              spellcheck: false,
            },
            {
              field: 'avatar_id',
              title: 'Avatar',
              type: 'uploader',
              mode: 'avatar'
            },
            {
              field: 'pulse_digest_enabled',
              type: 'toggle',
              label: 'Email Notifications',
              sublabel: 'Receive daily Pulse updates'
            },
            {
              field: 'company_name',
              title: 'Company Name',
              type: 'text',
              maxlength: 100,
              disabled: true,
              spellcheck: false,
            },
            {
              field: 'company_site',
              title: 'Company Website',
              type: 'url',
              maxlength: 1024,
              disabled: true,
              spellcheck: false,
            },
          ]
        },
        {
          type: 'container',
          className: 'textarea-container',
          opts: [
            {
              field: 'bio',
              title: 'Bio',
              type: 'textarea',
              placeholder: 'Enter your bio in order to train the AI models...',
              maxlength: 2048
            },
            {
              field: 'offering',
              title: 'My Offering',
              placeholder: 'Enter your offering in order to train the AI models...',
              type: 'textarea',
              maxlength: 2048
            }
          ],
        },

      ]
    }
  ]
}

export function makeSampleContentSchema() {
  return [
    {
      title: 'Post Examples',
      description: 'Please add up to 5 examples of your written content, such as LinkedIn posts, emails, and other communications. this content will help train the AI models.',
      type: 'uploader',
      mode: 'inline-text',
      file_type: SAMPLE_CONTENT.type,
      max_size: SAMPLE_CONTENT.max_size,
      rows: 5,
      max_uploads: 5,
      file_rows: 5
    }
  ]
}

export function makeSuperuserCapsSchema() {
  return [
    {
      field: 'su_g_calendar_enabled',
      type: 'checkbox',
      label: 'Allow integration with Google Calendar'
    },
    {
      field: 'su_ms_calendar_enabled',
      type: 'checkbox',
      label: 'Allow integration with Microsoft Outlook Calendar'
    },
    {
      field: 'su_salesforce_enabled',
      type: 'checkbox',
      label: 'Allow integration with Salesforce'
    },
    {
      field: 'su_other_companies_posts_enabled',
      type: 'checkbox',
      label: 'Allow posts generation for other companies in the feed'
    },
    {
      field: 'su_remind_onboarding',
      type: 'checkbox',
      label: 'Remind about incomplete onboarding'
    },
    {
      field: 'su_allow_any_topics',
      type: 'checkbox',
      label: 'Allow user-defined topics in Feed'
    }
  ]
}

export function makeGuardrailsSchema() {
  return [
    {
      field: 'su_censor_input_enabled',
      type: 'checkbox',
      label: 'Enable user input censor',
    },
    {
      field: 'su_injection_guard_enabled',
      type: 'checkbox',
      label: 'Enable prompt injection guardrail',
    },
    {
      field: 'su_scope_guard_enabled',
      type: 'checkbox',
      label: 'Enable prompt scope guardrail',
    },
    {
      field: 'su_egress_guard',
      type: 'button-group',
      title: 'Sensitive data egress guard',
      description: 'Prevents data from internal files from being sent to external tools such as web search, URL fetch, and Apollo.',
      opts: [
        {value: 'off', title: 'Off', description: 'No review of outbound tool calls.'},
        {value: 'drop', title: 'Block', description: 'Block external searches that contain internal data.'},
        {value: 'generalize', title: 'Generalize', description: 'Strip internal specifics from external searches, then run them.'}
      ]
    }
  ]
}

export function makeAdminCapsSchema() {
  return [
    {
      field: 'adm_agent_model',
      type: 'dropdown',
      placeholder: 'Select agent model',
      title: 'Agent model',
      className: 'agent-model',
      small: true,
      items: [
        {
          value: 'gpt-6.1-terra',
          title: 'GPT-6.1 Terra',
        },
        {
          value: 'gpt-6-sol',
          title: 'GPT-6 Sol',
        },
        {
          value: 'gpt-6-luna',
          title: 'GPT-6 Luna',
        },
        {
          value: 'gpt-5.6-sol',
          title: 'GPT-5.6 Sol',
        },
        {
          value: 'gpt-5.6-terra',
          title: 'GPT-5.6 Terra',
        },
        {
          value: 'gpt-5.6-luna',
          title: 'GPT-5.6 Luna',
        },
        {
          value: 'gpt-5.5',
          title: 'GPT-5.5',
        },
        {
          value: 'gpt-5.4',
          title: 'GPT-5.4 (default)',
        },
        {
          value: 'gpt-5.4-mini',
          title: 'GPT-5.4 Mini',
        },
        {
          value: 'gpt-5.2',
          title: 'GPT-5.2',
        }
      ]
    },
    {
      field: 'adm_beta_agent_model',
      type: 'dropdown',
      placeholder: 'Select beta agent model',
      title: 'Beta agent model',
      className: 'agent-model',
      small: true,
      items: [
        {
          value: 'gpt-6.1-terra',
          title: 'GPT-6.1 Terra',
        },
        {
          value: 'gpt-6-sol',
          title: 'GPT-6 Sol',
        },
        {
          value: 'gpt-6-luna',
          title: 'GPT-6 Luna',
        },
        {
          value: 'gpt-5.6-sol',
          title: 'GPT-5.6 Sol',
        },
        {
          value: 'gpt-5.6-terra',
          title: 'GPT-5.6 Terra',
        },
        {
          value: 'gpt-5.6-luna',
          title: 'GPT-5.6 Luna',
        },
        {
          value: 'gpt-5.5',
          title: 'GPT-5.5',
        },
        {
          value: 'gpt-5.4',
          title: 'GPT-5.4 (default)',
        },
        {
          value: 'gpt-5.4-mini',
          title: 'GPT-5.4 Mini',
        },
        {
          value: 'gpt-5.2',
          title: 'GPT-5.2',
        }
      ]
    },
    {
      field: 'adm_tgdata_enabled',
      type: 'checkbox',
      label: 'Allow Telecom data'
    },
    {
      field: 'adm_chat_sharing_enabled',
      type: 'checkbox',
      label: 'Enable Chat Sharing'
    },
    // {
    //   field: 'adm_use_gpt51_in_responder',
    //   type: 'checkbox',
    //   label: 'Use GPT-5.1 in responder'
    // },
    // {
    //   field: 'adm_use_gpt5_chat_in_responder',
    //   type: 'checkbox',
    //   label: 'Use GPT-5 chat in responder'
    // },
    // {
    //   field: 'adm_use_gpt5_in_responder',
    //   type: 'checkbox',
    //   label: 'Use GPT-5 in responder'
    // },
    {
      field: 'adm_early_feed_enabled',
      type: 'checkbox',
      label: 'Enable early feed'
    },
    {
      field: 'adm_agent_relevance_check_enabled',
      type: 'checkbox',
      label: 'Enable agent relevance check'
    },
    {
      field: 'adm_custom_cognito_emails_enabled',
      type: 'checkbox',
      label: 'Enable Custom Cognito Email Templates',
    },
    {
      field: 'adm_onboarding_enabled',
      type: 'checkbox',
      label: 'Enable onboarding',
    },
    {
      field: 'adm_pulse_semantic_search_enabled',
      type: 'checkbox',
      label: 'Enable semantic search in Pulse'
    },
    {
      field: 'adm_pulse_all_fields_semantic_search',
      type: 'checkbox',
      label: 'Use all fields in pulse semantic search'
    },

  ]
}

export function makeAgentsSchema() {
  return [
    {
      field: 'external_sources',
      type: 'link-saver',
      title: 'External sources',
      max_length: 5,
      description: 'Enables the AI agents (Person Card, Company Card, Meeting Prep Card) to incorporate insights, news, and trends from the user’s favorite sources, ensuring that all cards stay current with trusted, relevant information'
    }
  ]
}

export function makePulseSchema() {
  return [
    {
      type: 'container',
      dir: 'column',
      className: 'pulse-container',
      gap: '3rem',
      opts: [
        {
          field: 'adm_pulse_linking_optimization_mode',
          type: 'switch',
          label: 'Linking Optimization Mode'
        },
        {
          type: 'container',
          title: 'Scheduling & Data Refresh',
          className: 'pulse-system-container',
          gap: 0,
          opts: [
            {
              field: 'adm_pulse_news_scrape_period_hours',
              title: 'News Scrape Period (hours)',
              type: 'number'
            },
            {
              field: 'adm_pulse_posts_scrape_period_hours',
              title: 'Posts Scrape Period (hours)',
              type: 'number'
            },
            {
              field: 'adm_pulse_agent_run_interval_hours',
              title: 'Agents Run Interval (hours)',
              type: 'number'
            },
            {
              field: 'adm_pulse_pages_scrape_period_hours',
              title: 'Pages Scrape Period (hours)',
              type: 'number'
            },
            {
              field: 'adm_pulse_time_barrier_for_new_pages_hours',
              title: 'Time Barrier for New Pages (hours)',
              type: 'number'
            },
            {
              field: 'adm_pulse_path_selection_refresh_interval_hours',
              title: 'Path Selection Refresh Interval (hours)',
              type: 'number'
            },
            {
              field: 'adm_pulse_digest_period_hours',
              title: 'Digest Period (hours)',
              type: 'number'
            },
            {
              field: 'adm_pulse_youtube_scrape_period_hours',
              title: 'YouTube Scrape Period (hours)',
              type: 'number'
            },
            {
              field: 'adm_pulse_perplexity_scrape_period_hours',
              title: 'Perplexity Scrape Period (hours)',
              type: 'number'
            },
            {
              field: 'adm_job_change_check_period_hours',
              title: 'Job Change Check Period (hours)',
              type: 'number'
            },
            {
              field: 'adm_pulse_news_scraper_enabled',
              title: 'Enable News Scraper',
              type: 'switch'
            },
            {
              field: 'adm_pulse_posts_scraper_enabled',
              title: 'Enable Posts Scraper',
              type: 'switch'
            },
            {
              field: 'adm_pulse_pages_scraper_enabled',
              title: 'Enable Pages Scraper',
              type: 'switch'
            },
            {
              field: 'adm_pulse_youtube_scraper_enabled',
              title: 'Enable YouTube Scraper',
              type: 'switch'
            },
            {
              field: 'adm_pulse_perplexity_scraper_enabled',
              title: 'Enable Perplexity Scraper',
              type: 'switch'
            },
            {
              field: 'adm_pulse_native_language_search_enabled',
              title: 'Enable Native Language Search',
              type: 'switch'
            },
            {
              field: 'adm_job_change_signal_enabled',
              title: 'Enable Job Change Signals',
              type: 'switch'
            },

            {
              field: 'adm_pulse_topic_agents_enabled',
              title: 'Enable Topic Agents',
              type: 'switch'
            },
            {
              field: 'adm_pulse_cross_link_enabled',
              title: 'Enable Events Topic-Entity Cross Link',
              type: 'switch'
            },
            {
              field: 'adm_pulse_cross_retrieval_threshold',
              title: 'Pulse Cross-Linking Retrieval Threshold',
              type: 'number',
              step: 0.0001
            },
            {
              field: 'adm_pulse_cross_max_retrieved',
              title: 'Pulse Cross-Linking Max Retrieved',
              type: 'number'
            },
          ]
        },
        {
          type: 'container',
          title: 'Processing & Limit Settings',
          className: 'pulse-system-container',
          gap: 0,
          opts: [
            {
              field: 'adm_pulse_high_impact_limit',
              title: 'High Impact Limit',
              type: 'number'
            },
            {
              field: 'adm_pulse_max_iterations',
              title: 'Max Iterations',
              type: 'number'
            },
            {
              field: 'adm_pulse_events_per_entity',
              title: 'Events per Entity',
              type: 'number'
            },
            {
              field: 'adm_pulse_amount_of_relevant_posts',
              title: 'Amount of Relevant Posts',
              type: 'number'
            },

            {
              field: 'adm_pulse_max_retrieved',
              title: 'Max Retrieved',
              type: 'number'
            },
            {
              field: 'adm_pulse_prefetch_limit',
              title: 'Prefetch Limit (per vector)',
              type: 'number'
            },
            {
              field: 'adm_pulse_link_window_days',
              title: 'Linking Window (days)',
              type: 'number'
            },
            {
              field: 'adm_pulse_min_evidence_length',
              title: 'Min Evidence Length',
              type: 'number'
            },
            {
              field: 'adm_pulse_date_cutoff_months',
              title: 'Date Cutoff (months)',
              type: 'number'
            },
            {
              field: 'adm_pulse_match_probability_threshold',
              title: 'Match Probability Threshold',
              type: 'number',
              step: 0.0001
            },
            {
              field: 'adm_pulse_retrieval_threshold',
              title: 'Retrieval Threshold',
              type: 'number',
              step: 0.0001
            },
            {
              field: 'adm_pulse_decision_linking_enabled',
              title: 'Enable Decision Linking',
              type: 'switch'
            },
          ]
        },

      ]
    }
  ]
}

export function makeBetaSchema() {
  return [
    {
      field: 'adm_forced_beta_users',
      title: 'Emails',
      type: 'textarea',
      placeholder: 'Enter users emails here',
      maxlength: 20048,
      rows: 20,
      error: 'Please enter valid emails separated by commas.',
      validator: (text) => {
        const emails = text.split(',').map(e => e.trim())
        const regexp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
        return emails.every(email => regexp.test(email))
      }
    },
  ]
}
